<template>
  <BackgroundVideo
    class="landing-cover pl-0 pr-0"
    :img="cover"
    :sources="[coverVideo]"
    :style="{
      width: $vuetify.breakpoint.mdAndDown ? '100%' : '120%',
      height: $vuetify.breakpoint.mdAndDown ? '500px' : '836px',
      'margin-left': $vuetify.breakpoint.mdAndDown ? '0' : '-10%',
      position: $vuetify.breakpoint.mdAndDown ? '' : 'relative'
    }"
    overlay="linear-gradient(45deg,#2a4ae430,#fb949e6b)"
  >
    <v-layout
      :class="['landing-cover-layout', { 'is-small': $vuetify.breakpoint.mdAndDown }]"
      column
      align-center
      justify-center
      style="height: 100%"
    >
      <h1 class="landing-cover-title white--text">
        {{ $t('components.cover.title') }}
      </h1>

      <h2 class="landing-cover-subtitle white--text">
        {{ $t('components.cover.subtitle') }}
      </h2>

      <v-menu
        v-if="downloadGames.length && $vuetify.breakpoint.mdAndUp"
        top
        offset-y
        color="secondary"
      >
        <template #activator="{ on, attrs }">
          <button
            class="landing-cover-freetoplay-icon"
            v-bind="attrs"
            :aria-label="$t('components.cover.buttonPlay')"
            :aria-haspopup="true"
            :aria-expanded="attrs['aria-expanded'] || false"
            v-on="on"
          >
            {{ $t('components.cover.buttonPlay') }}
          </button>
        </template>

        <v-list role="menu">
          <v-list-item
            color="accent"
            role="menuitem"
          >
            <v-list-item-avatar>
              <img
                :src="logo"
                alt="GOZ logo"
              >
            </v-list-item-avatar>

            <v-list-item-content class="text-center">
              <v-list-item-title>Start your journey</v-list-item-title>
              <v-list-item-subtitle>Download the game</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn
                aria-label="Download game client"
                text
                icon
                color="#a4bdef"
              >
                <v-icon>fad fa-gamepad</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-list-item
            v-for="game in downloadGames"
            :key="game.id"
            role="menuitem"
            link
            tabindex="0"
            :aria-label="`Download ${$t(game.title)}`"
            @click="goTo(game.link)"
          >
            <div
              v-if="game.useImageAsBackground"
              class="v-list-item-background-image"
              :style="`background-image: url('${game.img}')`"
            >
              <div class="v-list-item-download-labels">
                <span
                  v-if="game.isNew"
                  class="downloadLabel downloadNew"
                >New</span>
                <span
                  v-if="game.isRecommend"
                  class="downloadLabel downloadRecommend"
                >Recommend</span>
                <span
                  v-if="game.isRecommend"
                  class="downloadLabel downloadComingSoon"
                >Coming Soon</span>
              </div>
            </div>

            <template v-else>
              <v-list-item-avatar size="25">
                <v-icon :aria-hidden="true">
                  {{ game.icon }}
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-title class="text-no-wrap">
                {{ $t(game.title) }}
                <div class="v-list-item-download-labels">
                  <span
                    v-if="game.isNew"
                    class="downloadLabel downloadNew"
                  >New</span>
                  <span
                    v-if="game.isRecommend"
                    class="downloadLabel downloadRecommend"
                  >Recommend</span>
                  <span
                    v-if="game.isRecommend"
                    class="downloadLabel downloadComingSoon"
                  >Coming Soon</span>
                </div>
              </v-list-item-title>
            </template>
          </v-list-item>
        </v-list>
      </v-menu>

      <button
        v-else
        class="landing-cover-freetoplay-icon"
        :aria-label="$t('components.cover.buttonPlay')"
        @click="goTo('#')"
      >
        {{ $t('components.cover.buttonPlay') }}
      </button>
    </v-layout>
  </BackgroundVideo>
</template>

<script>
import links from "@/constants/links.js";
import downloadGames from "@/constants/download.games";

export default {
    name: 'ZushinCover',
    data() {
        return {
            logo: links.assets.icon,
            downloadGames: downloadGames.list,
        }
    },
    computed: {
        cover: () => links.assets.cover,
        coverVideo: () => links.assets.coverVideo,
    },
    methods: {
        goTo(link) {
            window.open(link);
        },
    }
}
</script>
